import { PageLoadingIndicator } from './LoadingIndicator';
import { PageContainer } from '../layout/Layout';
import { ErrorBox } from './ErrorBox';
import React from 'react';
import { ApiRequest } from '../api/useApiRequest';
import { useOnMount } from '../helpers/hooks/useOnMount';

type Props<TRequestBody, TResponseBody> = {
  getDataRequest: ApiRequest<TRequestBody, TResponseBody>;
  genericErrorMessage?: string;
  children: ({
    response,
    sendRequest,
  }: { response: TResponseBody } & Pick<ApiRequest<TRequestBody, TResponseBody>, 'sendRequest'>) => React.ReactElement;
};

export const GetRequest = <TRequestBody, TResponseBody>({
  getDataRequest: { sendRequest, inProgress, error, response },
  genericErrorMessage,
  children,
}: Props<TRequestBody, TResponseBody>) => {
  useOnMount(() => {
    void sendRequest();
  });

  if (inProgress) {
    return <PageLoadingIndicator />;
  }

  if (error) {
    return (
      <PageContainer>
        <ErrorBox error={error} genericErrorMessage={genericErrorMessage} />
      </PageContainer>
    );
  }

  if (response !== null && response !== undefined) {
    return <>{children({ response, sendRequest })}</>;
  }

  return null;
};
